import { TopBar } from "@/components/TopBar";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LangLink } from "@/components/LangLink";
import { useLanguage } from "@/lib/language";
import { insightList } from "@/lib/insights";

const header = {
  eyebrow: { en: "Insights", ar: "مقالات ودلائل" },
  title: { en: "ISO Certification Guides", ar: "أدلة شهادات الأيزو" },
  subtitle: {
    en: "Clear, direct answers on ISO certification, cost, accreditation, and the oil and gas sector in Iraq and the Gulf.",
    ar: "إجابات واضحة ومباشرة حول شهادات الأيزو، والتكلفة، والاعتماد، وقطاع النفط والغاز في العراق والخليج.",
  },
};
const readLabel = { en: "Read the guide", ar: "اقرأ الدليل" };

export function InsightsIndex() {
  const { t } = useLanguage();
  return (
    <div className="min-h-screen bg-background">
      <TopBar />
      <Navbar />
      <main>
        <header className="border-b border-border bg-[#f7f5f1]">
          <div className="mx-auto max-w-3xl px-4 lg:px-8 py-20 sm:py-24 text-start">
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-primary">
              {t(header.eyebrow)}
            </span>
            <h1 className="mt-4 text-4xl font-extrabold leading-tight text-foreground sm:text-5xl">
              {t(header.title)}
            </h1>
            <p className="mt-5 text-lg leading-relaxed text-muted-foreground">
              {t(header.subtitle)}
            </p>
          </div>
        </header>

        <section className="mx-auto max-w-5xl px-4 lg:px-8 py-16 sm:py-20">
          <div className="grid gap-6 md:grid-cols-2">
            {insightList.map(({ meta }) => (
              <LangLink
                key={meta.slug}
                to={`/insights/${meta.slug}`}
                className="group flex h-full flex-col border-t border-border py-8 text-start transition-colors hover:border-primary"
              >
                <p className="mb-3 text-xs text-muted-foreground">
                  <time dateTime={meta.dateModified ?? meta.datePublished}>
                    {t(meta.dateLabel)}
                  </time>
                </p>
                <h2 className="text-xl font-bold text-card-foreground group-hover:text-primary">
                  {t(meta.title)}
                </h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">
                  {t(meta.description)}
                </p>
                <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">
                  {t(readLabel)}
                </span>
              </LangLink>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
